import React from 'react';

import { DetailsRowContainer, RequiredMark } from 'components/Entities/AddEntityModal/styles';
import { InputHeader } from 'containers/Audits/components/StartAuditModal/styles';

import { LabelRow } from '../../styles';

type FormRowProps = {
  testId: string;
  label: string;
  labelAddon?: React.ReactNode;
  children: React.ReactNode;
};

const FormRow: React.FunctionComponent<FormRowProps> = ({ testId, label, labelAddon, children }) => {
  const header = (
    <InputHeader>
      {label} <RequiredMark>*</RequiredMark>
    </InputHeader>
  );

  return (
    <DetailsRowContainer data-testid={testId}>
      {labelAddon ? (
        <LabelRow>
          {header}
          {labelAddon}
        </LabelRow>
      ) : (
        header
      )}
      {children}
    </DetailsRowContainer>
  );
};

export default FormRow;
